export default "__VITE_ASSET__CWOldy$$__"